export default __webpack_public_path__ + "assets/images/ilustracao-cadastro-pre-aprovado3e173abb149b42931bea70821ce8826e.png";